<!-- 任务1 -->
<template>
    <div>
        <div class="course_Task1">
            <el-row
                style="border: 1px solid #D3D3D3;margin: 0 20px 20px 20px;padding: 0 20px 20px 20px;min-height: calc(100vh - 280px);">
                <!-- <template v-if="examType == 2">
            <p style="background-color: rgb(239, 242, 247);margin: 0 -20px;color: #2789E2;padding: 20px;">任务得分：{{scoreInfo.score || 0}} 分 学习时长：{{scoreInfo.time || 0}} 分钟</p>
          </template> -->
                <p class="fontB"><i class="el-icon-document-remove icon_"></i>任务名称：<span style="font-weight: 500;">{{
                        taskInfo.taskTitle
                        }}</span></p>
                <p class="fontB"><i class="el-icon-s-data icon_" style="color: #8a39c2;"></i>任务分值：
                    <span style="font-weight: 500;">{{ taskInfo.taskScore }} 分</span>
                    <template v-if="examType == 2">
                        <span style="color: red;margin-left: 100px;">任务得分：{{ scoreInfo.score || 0 }} 分</span>
                        <span style="color: red;margin-left: 100px;">学习时长：{{ scoreInfo.time || 0 }} 分钟</span>
                    </template>
                </p>
                <p class="fontB"><i class="el-icon-document-copy icon_"></i>考核内容：</p>
                <el-row class="aljj">
                    <p>1、至少观看{{ taskInfo.assessmentRequirements }}分钟视频</p>
                    <p>2、每隔{{ taskInfo.assessmentTime }}分钟弹出一次验证框</p>
                </el-row>
                <p class="fontB"><i class="el-icon-edit-outline icon_" style="color: #2eb68e;"></i>考核任务：</p>
                <el-row>
                    <el-col :span="12">
                        <el-table border :data="tableData" style="width: calc(100% - 20px);">
                            <el-table-column type="index" header-align="center" align="center" width="100"
                                label="序号"></el-table-column>
                            <el-table-column prop="fileName" header-align="center" align="center"
                                label="视频名称"></el-table-column>
                            <el-table-column prop="schedule" header-align="center" align="center" label="进度"
                                width="100">
                                <template slot-scope="scope">

                                    <template v-if="scope.row.schedule >= 100">
                                        <span style="color: #2789E2;">已完成</span>
                                    </template>
                                    <template v-else>
                                        <span style="color: #F83131;">{{ scope.row.schedule || '-' }}
                                            {{ !$isEmpty(scope.row.schedule) ? '%' : "" }}</span>
                                    </template>
                                </template>
                            </el-table-column>
                            <el-table-column prop="_" header-align="center" align="center" label="操作" width="120">
                                <template slot-scope="scope">
                                    <el-link type="primary" :underline="false"
                                        @click="seeVideo(scope.row, scope.$index)">
                                        <span :style="'color:' + (onNum == scope.$index ? 'red' : '')">{{
                                            scope.row.schedule <= 0 ? "观看" : "继续观看" }}</span>
                                    </el-link>
                                </template>
                            </el-table-column>
                        </el-table>
                    </el-col>
                    <el-col :span="12" v-if='examType == 1'>
                        <el-row style="width: 100%;height: 300px">
                            <video @timeupdate="onTimeupdate" id="myVideo" controlslist="nodownload"
                                style="width: 100%;height: 100%;"
                                class="video-js vjs-default-skin vjs-big-play-centered" x-webkit-airplay="allow"
                                poster="" webkit-playsinline playsinline x5-video-player-type="h5"
                                x5-video-player-fullscreen="true" preload="auto">
                                <source type="application/x-mpegURL">
                            </video>
                        </el-row>
                    </el-col>
                </el-row>
                <el-row v-if='examType == 2 || examType == 3' style="margin: 20px 0;">
                    <el-row style="width: 50%;height: 400px;min-width: 500px;">
                        <video @timeupdate="onTimeupdate" id="myVideo" style="width: 100%;height: 100%;"
                            class="video-js vjs-default-skin vjs-big-play-centered" x-webkit-airplay="allow" poster=""
                            webkit-playsinline playsinline x5-video-player-type="h5" x5-video-player-fullscreen="true"
                            preload="auto">
                            <source type="application/x-mpegURL">
                        </video>
                    </el-row>
                </el-row>
            </el-row>
        </div>

        <el-dialog title="输入验证码继续观看" :showClose="false" :closeOnClickModal="false" :visible.sync="dialogVisible"
            width="500px">
            <el-row class="el_form_">
                <el-col :span="14" class="tc pr20">
                    <el-input v-model="verificationCode" clearable placeholder="请输入数字验证码"></el-input>
                </el-col>
                <el-col :span="10" class="tc">
                    <p class="m0" style="line-height: 38px;border: 1px solid #E1E1E1;border-radius: 3px;">
                        <SIdentify ref="SIdentify" v-if='dialogVisible'></SIdentify>
                    </p>
                </el-col>
            </el-row>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="confirmSIdentify">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
import SIdentify from "@/components/SIdentify"	//验证码
import jQuery from 'jquery'
export default {
    name: 'Task1',
    components: {
        SIdentify,
    },
    props: {
        courseType: { //课程类型 1教师开课 2系统授权
            type: Number,
            default: function () {
                return 1
            }
        },
        examType: { //考试类型 1：考试 2：查看成绩
            type: Number,
            default: function () {
                return 1
            }
        },
        taskId: { //任务ID
            type: String,
            default: function () {
                return ""
            }
        },
        handsOnId: { //实操ID
            type: String,
            default: function () {
                return ""
            }
        },
        scoreInfo: { //分值信息
            type: Object,
            default: function () {
                return {}
            }
        }
    },
    data() {
        return {
            tableData: [],
            studentHandsOnTaskVideoId: "",
            player: null,
            taskInfo: {}, //任务详情
            intervalInfo: null,
            num: 0, //进入提交的次数
            onTime: 0, //当前倒计时秒数
            onNum: 0, //当前播放的视频位置
            duration: 0, //视频时长
            currentTime: 0,
            dialogVisible: false,
            intervalUserInfo: null, //token过期
            verificationCode: "", //验证码
        }
    },
    created() {
        this.getInfo()
        if (this.examType != 3) {
            this.getCourseCentreVideoTask()
        }
    },
    mounted() {

    },
    methods: {
        getInfo() { //获取详情
            let url = "/api/teacherOpenCourseHandsOnSimulationTasks/getInfo.do"
            if (this.courseType == 2) {
                url = "/api/handsOnSimulationTasks/getInfo.do"
            }
            this.$get(url, { taskId: this.taskId }).then((ret) => {
                if (ret.code == 0) {
                    this.taskInfo = ret.data
                    if (this.taskInfo.assessmentTime > 20) {
                        this.intervalUserInfo = setInterval(() => {
                            this.getUserInfo()
                        }, 20 * 60 * 1000)
                    }
                    if (this.examType == 3) {
                        this.tableData = ret.data.teacherOpenCourseHandsOnSimulationTasksFileList
                        setTimeout(() => {
                            this.initVideo()
                        }, 200)
                    }
                    //this.tableData = ret.data.teacherOpenCourseHandsOnSimulationTasksFileList;
                } else {
                    this.$message({ message: ret.msg, type: 'error' })
                }
            })
        },
        initVideo(i) {
            let videoUrl = ""
            if (!this.$isEmpty(this.tableData) && this.tableData.length > 0) {
                videoUrl = this.$isHttp(this.tableData[i || 0].fileUrl)
            }
            let this_ = this
            this.player = this.$video(myVideo, {
                //确定播放器是否具有用户可以与之交互的控件。没有控件，启动视频播放的唯一方法是使用autoplay属性或通过Player API。
                controls: true,
                //自动播放属性,muted:静音播放
                autoplay: false,
                //建议浏览器是否应在<video>加载元素后立即开始下载视频数据。
                preload: "auto",
                autoDisable: true,
                //设置视频播放器的显示宽度（以像素为单位）
                // playbackRates: [0.5, 1, 1.5, 2],
                sources: [ // 视频源
                    {
                        src: videoUrl,
                        poster: '',
                        type: videoUrl.indexOf(".mp4") >= 0 ? 'video/mp4' : 'video/webm'
                    }]
            },
                function onPlayerReady() {
                    if (!this_.$isEmpty(this_.tableData) && this_.tableData.length > 0 && this_.tableData[0].schedule > 0 && this_.tableData[0].schedule < 100) {
                        setTimeout(() => {
                            let t = this_.duration * this_.tableData[0].schedule / 100
                            this_.player.currentTime(Math.floor(t)) //指定视频的开始播放位置
                        }, 300)
                    }
                })

            var elevideo = document.getElementById("myVideo")
            elevideo.addEventListener('ended', () => { //结束
                this.num = 0
                console.log("播放结束")
            }, true)
            elevideo.addEventListener('play', () => { //播放开始执行的函数
                console.log("开始播放")
                if (this.intervalInfo) {
                    clearInterval(this.intervalInfo)
                }
                this.onTime = 0
                if (this.examType == 1) {
                    this.timerInfo() //开始计时
                }
                //执行开始播放的路平级
            }, true)
            elevideo.addEventListener('pause', () => { //暂停开始执行的函数
                console.log("暂停播放")
                clearInterval(this.intervalInfo) //停止计时
                // 执行暂停的逻辑
            }, true)
            // jQuery('video').bind('contextmenu',function() { return false; }); //禁止右键
            // jQuery('.vjs-progress-control').hide(); //禁止右键
        },
        seeVideo(item, index) { //查看视频
            this.onNum = index
            this.player.src({ src: this.$isHttp(item.fileUrl), type: item.fileUrl.indexOf(".mp4") >= 0 ? 'video/mp4' : 'video/webm' })
            if (!this.$isEmpty(this.tableData) && this.tableData.length > 0 && this.tableData[index].schedule > 0 && this.tableData[index].schedule < 100) {
                setTimeout(() => {
                    let t = this.duration * this.tableData[index].schedule / 100
                    this.player.currentTime(Math.floor(t)) //指定视频的开始播放位置
                }, 300)
            }
            this.player.play() //播放
        },
        getCourseCentreVideoTask() { //获取学生观看视频数据
            this.$get("/api/studentHandsOnTaskVideo/getCourseCentreVideoTask", { taskId: this.taskId, sourceType: this.examType, courseType: this.courseType }).then((ret) => {
                if (ret.code == 0) {
                    this.tableData = ret.data.videoFiles
                    this.studentHandsOnTaskVideoId = ret.data.studentHandsOnTaskVideoId
                    this.initVideo()
                } else {
                    this.$message({ message: ret.msg, type: 'error' })
                }
            })
        },
        editTaskVideo(param) {
            param.handsOnTaskId = this.taskId
            param.handsOnId = this.handsOnId
            param.studentHandsOnTaskVideoId = this.studentHandsOnTaskVideoId
            param.courseType = this.courseType
            this.$post('/api/studentHandsOnTaskVideo/addCourseCentreVideoTask', param).then((ret) => {
                if (ret.code == 0) {

                } else {
                    this.$message({ message: ret.msg, type: 'error' })
                }
            })
        },
        /**
         * videoFile:[{fileName:"", schedule: "", fileUrl: ""}]
         * fileName文件名
         * schedule 进度
         * fileUrl 文件地址
         */
        onTimeupdate(e) { //判断是否播放完成  总时长：e.target.duration 当前播放时长：e.target.currentTime
            if (this.examType == 1) {
                this.num++ //按照视频每250毫秒触发一次来计算 5秒提交一次数据保存
                if (e.target.currentTime > 0 && e.target.duration != e.target.currentTime && this.num >= 20) {
                    this.num = 0
                    if (this.tableData[this.onNum].schedule < 100) {
                        let schedule = Math.floor((e.target.currentTime / e.target.duration) * 100)//计算出播放百分比
                        this.tableData[this.onNum].schedule = schedule
                        this.editTaskVideo({ videoFile: JSON.stringify(this.tableData) })
                    }
                } else if (e.target.duration == e.target.currentTime) { //完成时 直接提交
                    this.num = 0
                    if (this.tableData[this.onNum].schedule < 100) {
                        this.tableData[this.onNum].schedule = 100
                        this.editTaskVideo({ videoFile: JSON.stringify(this.tableData) })
                    }
                }
                if (e.target.currentTime <= 0) {
                    setTimeout(() => {
                        this.duration = e.target.duration
                        this.currentTime = e.target.currentTime
                    }, 100)
                }
            }
        },
        timerInfo() {
            let assessmentTime = this.taskInfo.assessmentTime //多少间隔停止一次（分钟）
            if (assessmentTime <= 0) {
                this.intervalInfo = setInterval(() => {
                    this.taskLogInfo()
                }, 5000)
                return
            }
            // this.intervalInfo = setInterval(()=>{
            //   this.player.pause();//暂停
            //   this.dialogVisible = true;
            //   clearInterval(this.intervalInfo);
            // },assessmentTime * 60 * 1000);

            this.intervalInfo = setInterval(() => {
                this.onTime++
                if (this.onTime == assessmentTime * 60) {
                    this.player.pause()//暂停
                    this.dialogVisible = true
                    this.onTime = 0
                    clearInterval(this.intervalInfo)
                    //调用退出全屏，因为全屏会挡住验证码对话框
                    this.exitFullscreen()
                }
                if (this.onTime % 5 == 0) { //5秒钟调用一次数据修改
                    this.taskLogInfo()
                }
            }, 1000)

        },
        taskLogInfo() {
            this.$post('/api/studentHandsOnTaskLog/addCourseCentreTaskLog.do', { handsOnTaskId: this.taskId, taskType: "TASK_VIDEO", courseType: this.courseType }).then((ret) => {
                if (ret.code == 0) {

                } else {
                    this.$message({ message: ret.msg, type: 'error' })
                }
            })
        },
        confirmSIdentify() { //确认验证码
            if (this.verificationCode == this.$refs.SIdentify.identifyCodeTemp) {
                this.verificationCode = ''
                this.dialogVisible = false
                if (this.taskInfo.assessmentTime <= 20) {
                    this.getUserInfo()
                }
            } else {
                this.$message.warning("验证码错误！")
                return
            }
        },
        getUserInfo() { //主要用于避免看视频时避免token过期
            this.$post("/api/base/userInfo.do").then((ret) => {

            })
        },
        exitFullscreen() { //退出全屏
            if (document.exitFullScreen) {
                document.exitFullScreen()
            } else if (document.mozCancelFullScreen) {
                document.mozCancelFullScreen()
            } else if (document.webkitExitFullscreen) {
                document.webkitExitFullscreen()
            } else if (element.msExitFullscreen) {
                element.msExitFullscreen()
            }
        }
    },
    beforeDestroy(key) { //退出时
        if (this.player) {
            this.player.dispose()
        }
        this.editTaskVideo({ videoFile: JSON.stringify(this.tableData) })
        if (this.intervalInfo) {
            clearInterval(this.intervalInfo)
        }
        if (this.intervalUserInfo) {
            clearInterval(this.intervalUserInfo)
        }
    }
}
</script>
<style lang="less">
.course_Task1 {
    .icon_ {
        color: #2789E2;
        margin-right: 10px;
    }

    .has-gutter {
        th {
            border-color: #E5E5E5;
            background-color: #EFF2F7;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/lookCourse/components/PracticalTraining/Task1.vue